var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row ruleWithPausedCmps"},[_c('switch-button',{attrs:{"checked":_vm.ruleWithPausedCampaigns,"hover-title":{ enabled: 'Disable', disabled: 'Enable' },"update":(value) => _vm.$_updateApplyToPausedCampaigns(value)}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-with-info"},[_vm._v("Execute rule even when "),_c('strong',[_vm._v("campaigns are paused")])])
}]

export { render, staticRenderFns }